import React, { useEffect, useState } from "react";
import style from "./style.module.css";
import LogoGym from "../../Picture/logoKekes.png";
import { useNavigate } from "react-router-dom";

const AttendanceGym1MemberBaru=(props)=>{
    const [nama,setNama]=useState("");
    const [alamat,setAlamat]=useState("");
    const [nomorHandphone,setNomorHandphone]=useState("");
    const [status,setStatus]=useState("Pilih");
    const [waktuMember,setWaktuMember]=useState("Pilih");
    const [expiredMember,setExpiredMember]=useState("");
    const [pembayaran,setPembayaran]=useState("Pilih");
    const [gender,setGender]=useState("Pilih");
    const [member,setMember]=useState(false);
    const [keteranganKirim,setKeteranganKirim]=useState("");
    const [trainer,setTrainer]=useState(false);
    const url = props.url;
    const rfid =localStorage.getItem("rfid");

const navigate =useNavigate("");
    //function klik logo gym
    const KlikLogoGym=()=>{
        navigate("/gym1/attendance");
    }

// helper: format YYYY-MM-DD (lokal)
function formatLocalYYYYMMDD(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// helper: tambah hari
function tambahHari(startDate, jumlahHari) {
  const d = new Date(startDate);
  d.setDate(d.getDate() + jumlahHari);
  return d;
}

// function ubah waktu member
const WaktuMember = (value) => {
  setWaktuMember(value);

  const now = new Date();
  let daysToAdd = 0;
  if (value === "Member 1 Bulan") daysToAdd = 30;
  else if (value === "Member 3 Bulan") daysToAdd = 90;
  else if (value === "Member 6 Bulan") daysToAdd = 180;
  else if (value === "Member 12 Bulan") daysToAdd = 365;
  else {
    setExpiredMember("");
    return;
  }

  const expiredDate = tambahHari(now, daysToAdd);


  setExpiredMember(formatLocalYYYYMMDD(expiredDate));
};
// function pilih status
const Status=(value)=>{
    setStatus(value);
    if(value === "Member Umum" || value === "Member Pelajar"){
        setMember(true);
        setTrainer(false);
    }else if(value === "Trainer"){
setMember(false);
setTrainer(true);
    }else{
        setMember(false);
        setTrainer(false);
    }
}
// fucntion clear
const Clear=()=>{
    setNama("");
    setAlamat("");
    setNomorHandphone("");
    setStatus("Pilih");
    setWaktuMember("Pilih");
    setExpiredMember("");
    setPembayaran("Pilih");
    setGender("Pilih");
    localStorage.removeItem("rfid");
}
// function klik kirim
const KlikKirim=()=>{

    
if(status==="Member Umum"|| status ==="Member Pelajar"){
    if(nama ===""||alamat===""||nomorHandphone===""||waktuMember==="Pilih"||pembayaran==="Pilih"){
        setKeteranganKirim("Data tidak lengkap");
    }else{
        fetch(url + "/?op=inputMemberBaruGym", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "rfid="+rfid+
      "&nama="+nama+
      "&alamat="+alamat+
      "&nomor="+nomorHandphone+
      "&status="+status+
      "&waktu="+waktuMember+
      "&pembayaran="+pembayaran+
      "&waktuExpired="+expiredMember
      
    })
    .then((response) => response.json())
    .then((json)=>{
    
        if(json==="berhasil"){
            Clear();
            setKeteranganKirim("Data berhasil terkirim");
            setTimeout(() => {
    setKeteranganKirim("");
    navigate("/gym1/attendance")
  }, 1000);
        }
    })
}
 } else if (status==="Trainer"){
if(nama ===""||alamat===""||nomorHandphone===""){
        setKeteranganKirim("Data tidak lengkap");
    }else{
        fetch(url + "/?op=inputTrainerBaruGym", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "rfid="+rfid+
      "&nama="+nama+
      "&alamat="+alamat+
      "&nomor="+nomorHandphone+
      "&status="+status+
      "&gender="+gender
      
    })
    .then((response) => response.json())
    .then((json)=>{
    
        if(json==="berhasil"){
            Clear();
            setKeteranganKirim("Data berhasil terkirim");
            setTimeout(() => {
    setKeteranganKirim("");
    navigate("/gym1/attendance")
  }, 1000);
        }
    })
}
} else if (status==="Karyawan"){
if(nama ===""||alamat===""||nomorHandphone===""){
        setKeteranganKirim("Data tidak lengkap");
    }else{
        fetch(url + "/?op=inputKaryawanBaruGym", {
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "rfid="+rfid+
      "&nama="+nama+
      "&alamat="+alamat+
      "&nomor="+nomorHandphone+
      "&status="+status
      
      
    })
    .then((response) => response.json())
    .then((json)=>{
    
        if(json==="berhasil"){
            Clear();
            setKeteranganKirim("Data berhasil terkirim");
            setTimeout(() => {
    setKeteranganKirim("");
    navigate("/gym1/attendance")
  }, 1000);
        }
    })
}
} else{
    setKeteranganKirim("Data tidak lengkap");
}

}

// use effect cek session
   useEffect(()=>{
       fetch(url + "/?op=cekSession", {
           credentials: "include", 
         })
         .then((response)=>response.json())
         .then((json)=>{
          
         if (json === "kosong") {
               navigate("/", { replace: true });
             }else if(json ==="gym2"){
   navigate("/gym2", { replace: true });
             }else if(json ==="owner"){
   navigate("/owner", { replace: true });
             }
         })
       },[])
return(
    <div className={style.containerAll}>
<div className={style.containerJudul}>
    New Member
    <div style={{cursor:"pointer"}} onClick={()=>KlikLogoGym()}>
        <img src={LogoGym}/>
    </div>
    </div>
    <div className={style.containerIsi}>
<div className={style.divForm}>
<div className={style.judulForm}>
Buat Member
</div>
<div className={style.divIsiForm}>
<div className={style.divInputan}>
    <div>
Nama
    </div>
    <input onChange={(e)=>setNama(e.target.value.toUpperCase())} value={nama}/>
</div>
<div className={style.divInputan}>
    <div>
Alamat
    </div>
    <input onChange={(e)=>setAlamat(e.target.value.toUpperCase())} value={alamat}/>
</div>
<div className={style.divInputan}>
    <div>
Nomor Handphone
    </div>
    <input onChange={(e)=>setNomorHandphone(e.target.value)} type="number" value={nomorHandphone}/>
</div>
<div className={`${style.divInputan} ${style.status}`}>
    <div>
Status
    </div>
    <input type="number" disabled={true}/>
    <select value={status} onChange={(e)=>{
        Status(e.target.value)

    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="Member Umum">
            Member Umum
        </option>
        <option value="Member Pelajar">
            Member Pelajar
        </option>
         <option value="Karyawan">
            Karyawan
        </option>
         <option value="Trainer">
            Trainer
        </option>
    
    </select>
</div>
<div style={{display:member?"flex":"none"}} className={style.divInputan}>
    <div>
Waktu Member
    </div>
    <input type="number" disabled={true}/>
    <select value={waktuMember} onChange={(e)=>{
        WaktuMember(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="Member 1 Bulan">
            1 Bulan
        </option>
        <option value="Member 3 Bulan">
            3 Bulan
        </option>
        <option value="Member 6 Bulan">
            6 Bulan
        </option>
       <option value="Member 12 Bulan">
            12 Bulan
        </option>
    
    </select>
</div>
<div style={{display:member?"flex":"none"}} className={style.divInputan}>
    <div>
Expired Member
    </div>
    <input disabled={true}  value={expiredMember}/>
</div>
<div style={{display:member?"flex":"none"}} className={`${style.divInputan} ${style.divPembayaran}`}>
    <div>
Pembayaran
    </div>
    <input type="number" disabled={true}/>
    <select value={pembayaran} onChange={(e)=>{
        setPembayaran(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="Cash">
         Cash
        </option>
        <option value="Non Cash">
            Non Cash
        </option>
       
    </select>
</div>
<div style={{display:trainer?"flex":"none"}} className={`${style.divInputan} ${style.gender}`}>
    <div>
Gender
    </div>
    <input type="number" disabled={true}/>
    <select value={gender} onChange={(e)=>{
        setGender(e.target.value)
    }}>
        <option value="Pilih">
            Pilih
        </option>
        <option value="cowok">
            cowok
        </option>
        <option value="cewek">
            cewek
        </option>
        
    
    </select>
</div>


</div>
<div className={style.divKirim}>
<div style={{color:keteranganKirim==="Data berhasil terkirim"?"blue":"red"}} className={style.keteranganKirim}>
{keteranganKirim}
</div>
<button onClick={()=>KlikKirim()} className={style.buttonKirim}>
Kirim
</button>

</div>
</div>
    </div>
    </div>
)
}
export default AttendanceGym1MemberBaru;